import React, { FC, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import "./Comprete.scss";

interface CompreteProps {}

const Comprete: FC<CompreteProps> = () => {
  const location = useLocation();

  const [file, setFile] = useState<File>();
  const copyRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    setFile(location.state as File);
    window.scrollTo(0, 0);
  }, [location.state]);

  const copyToClipboard = async () => {
    const hash = copyRef.current.innerHTML;
    navigator.clipboard.writeText(hash).then(()=>{
      alert("「#サービス名」をコピーしました");
    });
  };

  return (
    <div className="Comprete" data-testid="Comprete">
      <div className="header">
        <h2>保存が完了しました！</h2>
        <p>
          ハッシュタグと一緒にSNSに投稿して
          <br />
          思い出を共有しましょう
        </p>
        <button className="hash" onClick={copyToClipboard} ref={copyRef}>
          #ロクマイ
        </button>
      </div>

      <div className="imgWrap">
        <img src={`${process.env.PUBLIC_URL}/img/imgwrap-top.svg`} alt="" />
        {file && (
          <div className="filewrap">
            <img
              src={(window.URL || window.webkitURL).createObjectURL(file)}
              alt=""
            />
          </div>
        )}
        <img src={`${process.env.PUBLIC_URL}/img/imgwrap-bottom.svg`} alt="" />
      </div>

      <div className="bottom">
        <p>思い出の写真は、フォトブックに残しませんか？</p>
        <img
          src={`${process.env.PUBLIC_URL}/img/photobackLite.png`}
          alt="photoback lite"
        />
      </div>
    </div>
  );
};

export default Comprete;
